import { request_detail, request_list, update_detail, create_detail, remove_detail, request_header, import_list } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import configs from '@/configs';
import Vue from 'vue';
const endpoint = 'bigpackage'

// initial state
const state = {
    loading: false,
    notTransit: [],
    inTQ: [],
    all: {},
    selected: {
        ID: 0,
        PackageCode: '',
        ReceivePlaceID: 1,
        Weight: 0,
        Volume: 0,
        Amount: 0,
        Status: 0,
        Packages: []
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setBigPackageList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getListNotTransit({ commit }) {
        var param = {'not_tran': true}
        request_list(endpoint, data => {
            commit('setListNotTransit', data);
        }, Vue.http, param, this.state.authentication.token);
    },
    getListInTQ({ commit }) {
        var param = {'in_tq': true}
        request_list(endpoint, data => {
            commit('setListInTQ', data);
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, {id, param}) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token, param);
    },
    setDetail({ dispatch }, {data, id, param}) {
        if(id > 0) {
            data.ModifiedBy = this.state.authentication.user.username;
            update_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể cập nhật bao hàng.')
                }
                else {
                    sendSuccessNotice('Cập nhật bao hàng thành công.')
                    refreshResource();
                }
            }, Vue.http, data, id, this.state.authentication.token);
        }
        else {
            data.CreatedBy = this.state.authentication.user.username;
            delete data.ID;
            create_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể thêm mới bao hàng.')
                }
                else {
                    sendSuccessNotice('Thêm mới bao hàng thành công.');
                    refreshResource();
                }
            }, Vue.http, data, this.state.authentication.token);
        }
    },
    removeDetail({ commit }, id) {
        if(id == 0) {
            return;
        }
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa bao hàng.')
            }
            else {
                sendSuccessNotice('Đã xóa bao hàng thành công.')
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    addNewTrancode({dispatch}, {tran_code, package_id, only_update, param}) {
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        var req = {
          'TransactionCode': tran_code,
          'Status': 4,
          'only_update': only_update,
          'BigPackageID': package_id
        }
        Vue.http.post(`${process.env.VUE_APP_ENDPOINT}/admin/api/bigpackage/new-trancode-vn/`, req, header).then(function (res) {
            refreshResource();
            sendSuccessNotice('Nhập kho mã vận đơn thành công.')
        },
        function (err) {
          if(err.status == 401) {
            window.getApp.$emit("APP_AUTH_FAILED");
          }
          else if(err.status == 406) {
            sendErrorNotice(err.data.reason);
            refreshResource();
          }
        });
    },
    import_transaction({ commit }, formData) {
        commit("setLoading", { loading: true });
        import_list(endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason)                    
            }
            else {
                sendSuccessNotice('Nhập kho mã vận đơn thành công.')
                refreshResource();
            }
            
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
};

// mutations
const mutations = {
    setBigPackageList(state, data) {
        state.all = data;
    },
    setListNotTransit(state, data) {
        state.notTransit = data.data;
    },
    setListInTQ(state, data) {
        state.inTQ = data.data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
